import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.8.067C.844.067.067.844.067 1.8S.844 3.533 1.8 3.533 3.533 2.756 3.533 1.8 2.756.067 1.8.067M1.8 5.267C.844 5.267.067 6.044.067 7S.844 8.733 1.8 8.733 3.533 7.956 3.533 7 2.756 5.267 1.8 5.267M1.8 10.467c-.956 0-1.733.777-1.733 1.733s.777 1.733 1.733 1.733 1.733-.777 1.733-1.733-.777-1.733-1.733-1.733M7 .067c-.956 0-1.733.777-1.733 1.733S6.044 3.533 7 3.533 8.733 2.756 8.733 1.8 7.956.067 7 .067M7 5.267c-.956 0-1.733.777-1.733 1.733S6.044 8.733 7 8.733 8.733 7.956 8.733 7 7.956 5.267 7 5.267M7 10.467c-.956 0-1.733.777-1.733 1.733S6.044 13.933 7 13.933s1.733-.777 1.733-1.733S7.956 10.467 7 10.467M12.2 3.533c.956 0 1.733-.777 1.733-1.733S13.156.067 12.2.067 10.467.844 10.467 1.8s.777 1.733 1.733 1.733M12.2 5.267c-.956 0-1.733.777-1.733 1.733s.777 1.733 1.733 1.733S13.933 7.956 13.933 7s-.777-1.733-1.733-1.733M12.2 10.467c-.956 0-1.733.777-1.733 1.733s.777 1.733 1.733 1.733 1.733-.777 1.733-1.733-.777-1.733-1.733-1.733"
    }, null, -1)
  ]))]))
}
export default { render: render }